import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="text-center bold mb-5">* * *</p>
    
    <p class="mb-3">
      Reen, reen, senĉese reen volviĝis liaj pensoj.
    </p>

    <p class="mb-3">
      En firma nepenetrebla skatolo de lia kranio flagris kaj eksplodis senelira morno.
    </p>

    <p class="mb-3">
      Senelire staris li ĉe la muro.
    </p>

    <p class="mb-3">
      Post kelkaj minutoj oni mortigos lin.
    </p>

    <p class="mb-3">
      Plena ondo de vivopovo subite superinundis lin.
    </p>

    <p class="mb-3">
      Per flava flamo li soris supren, al la ĉielo, al la suno.
    </p>

    <p class="mb-3">
      Varmecon de la Suno eksentis li, kaj varma flav-ruĝa makulo superverŝis lin, dissolvis, diskorpuskuligis en tiu varmega Suno, senlima mondo.
    </p>

    <p class="mb-3">
      Post kelkaj minutoj li estis morta.
    </p>

    <p class="mb-5">
      Kaj libera.
    </p>


    <p class="text-center bold mb-5">* * *</p>


    <p class="mb-3">
      Li iris laŭ la ponto.
    </p>

    <p class="mb-3">
      Maldika, griza, alta, li enpikiĝis en la spacon – kaj subite falis malsupren, kvazaŭ senforte, kun pendantaj brakoj.
    </p>

    <p class="mb-3">
      Sube kuregis aŭtoj, senvoĉaj kaj rapidaj.
    </p>

    <p class="mb-3">
      Apude estis griza ĉielo kaj griza spaco.
    </p>

    <p class="mb-3">
      Ĉielo proksimiĝis.
    </p>

    <p class="mb-3">
      Li iris rekte tien, al griza ĉielo, dissolviĝante en ĝi, mem griza kaj senespera; li kreis sian mondon, la mondo kreis lin, kaj ili ambaŭ dissolviĝis unu en la alia.
    </p>

    <p class="mb-5">
      Nenio.
    </p>


    <p class="mb-3">
      Lia korpo en blua ĉemizo kaj ĝinsoj kuŝis inter aŭtoj sur griza pavimo, el-sub la kapo makuliĝis obskura flako.
    </p>

    <p class="mb-3">
      Svarmis ruĝ-violaj aŭtoj.
    </p>

    <p class="mb-3">
      Ne plu estis griza mondo. Finiĝis senespero.
    </p>

    <p class="mb-5">
      La korpo de la Savinto de la mondo kuŝis sur la griza pavimo sub la ponto. Bluis ĉemizo. Ruĝis aŭtoj.
    </p>


    <p class="text-center bold mb-5">* * *</p>


    <p class="mb-3">
      La pleneco de materio inundis lin. Jen densiĝis la juneco, tiom malproksima, jam travidebla, oscilanta, vakua. 
      Solidiĝis aĵoj en ilia firma tuŝebleco; ektintis, eksonoris, ekflamis sonoj; odoroj superŝutis lin kiel striktaj insuletoj; ĉio brilis en flavega varma suno.
    </p>

    <p class="mb-3">
      Vento de vivpleneco denove glitis sur liaj vangoj; maro…atendis lin…
    </p>

    <p class="mb-3">
      Laŭ kurbaj ŝtonaj stratetoj malsupreniris li al la maro. 
      Ŝtonaj koridoroj kondukis lin tien, kie, sub blua marĉielo, la rokoj montris sian grizan potencon. 
      La sama potenco tiris lin al kaskado de gutoj, grapoloj da akvo, kreskantaj sur blua ĉiela fono.
    </p>

    <p class="mb-3">
      «Fontanoj de kristal’», la vivifonto…
    </p>

    <p class="mb-5">
      Ankoraŭ unu paŝo – kaj per tuta sia pezo akvoarboj ruinfaligis lin, disbatante lin, dispecigante lin je la samaj gutoj, eroj, kiaj ili mem estis.
    </p>

    <p class="mb-5">
      Li kunsolviĝis kun la «primara potenco».
    </p>


    <p class="text-center bold mb-5">Dialogo de geedza paro en iu ermita kavano dum mielmonato</p>


    <p class="mb-3">
      – Mi estas tute senfortigita.
    </p>
    
    <p class="mb-3">
      – Nu eltenu vi, almenaŭ por nelonge. Baldaŭ printempo…
    </p>
    
    <p class="mb-3">
      – Ne. Por kia diablo mi venis ĉi tien? Mi ne plu volas. Mi deziras hejmen.
    </p>
    
    <p class="mb-3">
      – Ne, mi revenos. 
      Vi promesis al mi tutan mondon, kaj jen, ni eĉ najlon ne havas. 
      Ni pereas poiomete, senhelpaj kaj malsataj…
    </p>
    
    <p class="mb-3">
      – Nu komprenu, almenaŭ ni estas ja tute solaj. 
      Neniu zorgas pri ni, ni ne plu vidas homojn kun iliaj abomenaj vizaĝoj… 
      Ĉu gravas, kiel ni loĝas, se la plej grava estas, ke ni ne vidas homojn?
    </p>
    
    <p class="mb-3">
      – Jes…
    </p>
    
    <p class="mb-3">
      – Memoru iliajn ridaĉojn, stultajn okulojn, kotan tuŝon de iliaj manoj, parolojn, parolojn!… 
      Sen iu ajn vorto de vero, sincero, bonkoro…
    </p>
    
    <p class="mb-5">
      – Ĉu vi opinias, ke vi estas pli bona ol ili? 
      Ankaŭ vi estas homo, kaj same abomena por mi. 
      Mi preferus vivi kun multaj, senrilataj al mi – min ja ili ne tuŝas, ne maltrankviligas. 
      Sed vi – kiel abomena estas la vivo kun vi, ĉiam plendanta, pita, sendigna! 
      Kiel vi tedegis al mi! 
      Mi povus, plene povus malami homojn, se ili similas vin, nulaĵo! 
      Neniun mi malamis dum mia vivo, nur vin; neniun homon krom vi!
    </p>
    

    <p class="text-center bold mb-3">Savi sin mem…</p>
    
    
    <p class="mb-3">
    Mi venis al tiu loko subite.
    </p>
    
    <p class="mb-3">
      Jen mi kliniĝis por ĝustigi la bukon sur la ŝuo… kapbalanciĝo, eble sveno – kaj jen mi staras en tute alia… lando? mondo? sonĝo?
    </p>
    
    <p class="mb-3">
      Ĉirkaŭ mi sternas sin senfina, okulojn ensorbanta stepo: varma, flava, mola. 
      La vidaĵo karesas koron; raran kvieton sugestas tiu senlima spaco, libera, libera…
    </p>
    
    <p class="mb-3">
      Jes, ĝuste tiu jam forgesita sento de trankvilo kaj libero trafis min.
    </p>
    
    <p class="mb-3">
      Sed kie mi estas?
    </p>
    
    <p class="mb-3">
      Ĉielo -- blua, suno – flava, plantaro – verdeflava, sukcena, kvazaŭ sekigita kaj matura, kiel en aŭtuno.
    </p>
    
    <p class="mb-3">
      Sed ĵus ĉirkaŭ mi staris nigra kaj plumba, senesperiga decembro, fino de jaro, fino de vivo…
    </p>
    
    <p class="mb-3">
      Ĉu mia senespero kaj senpovo vivi en tiu mondo translokigis min en la alian? 
    </p>
    
    <p class="mb-3">
      Ĉu mi mem kreis por mi azilon?
    </p>
    
    <p class="mb-3">
      Sed ĉu gravas tio? 
      Mi jam estas ĉi tie, kaj nur tio gravas. 
      Mi saviĝis de tiu vivo, kaj des pli bone, ke mi saviĝis per mia propra forto, dank’ al mi mem. 
    </p>

    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Sur mia ekrano aperis konsternita vizaĝo de Tiu. 
      Li turnadis la kapon kun miraj okuloj; sed post kelkaj minutoj li tute trankviliĝis kaj sur lia vizaĝo aperis esprimo de profunda ĝuo. 
      Do, ni ne eraris. Ni trovis ĝuste Tiun, kiun ni bezonis. Aŭ li bezonis nin.
    </p>
    
    <p class="text-center mb-3">* * *</p>

    <p class="mb-3">
      Li pasigis duonhoron en plena kaj profunda silento, kaj poste ekpaŝis poiomete al sudo. 
      Ni sekvis lin ĝis unua prekono, kaj poste elŝaltis la ekranon. 
      Ni lasu lin libera.
    </p>
    `
  )
}

const itemName = {
  esp: 'Kelkaj fragmentoj el la jaroj 1990-aj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;